import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../utils/api";

const BASE_URL = "https://api.freshcart4u.com";

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [loading, setLoading] = useState(true);

  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");

  /* ================= IMAGE ================= */
  const getImage = (img) => {
    if (!img) return "https://via.placeholder.com/500";
    if (img.startsWith("http")) return img;
    return `${BASE_URL}${img}`;
  };

  /* ================= FINAL PRICE ================= */
  const getFinalPrice = (p) => {
    if (p.offerType === "PERCENT") {
      return p.price - Math.round((p.price * p.offerValue) / 100);
    }
    if (p.offerType === "FLAT") {
      return p.price - p.offerValue;
    }
    return p.price;
  };

  /* ================= FETCH PRODUCT ================= */
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await api.get(`/api/products/${id}`);
        setProduct(res.data.product);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  /* ================= ADD TO CART ================= */
  const addToCart = async () => {
    if (!token || !userId) {
      Swal.fire("Login Required", "Please login first", "warning");
      return;
    }

    await api.post("/api/cart/add", {
      userId,
      productId: product._id,
      quantity: qty,
    });

    window.dispatchEvent(new Event("cartUpdated"));

    Swal.fire({
      icon: "success",
      title: "Added to Cart",
      timer: 900,
      showConfirmButton: false,
    });
  };

  /* ================= BUY NOW ================= */
  const buyNow = async () => {
    if (!token || !userId) {
      Swal.fire("Login Required", "Please login first", "warning");
      return;
    }

    await api.post("/api/cart/add", {
      userId,
      productId: product._id,
      quantity: qty,
    });

    window.dispatchEvent(new Event("cartUpdated"));
    navigate("/checkout");
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <p>Loading product...</p>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="text-center mt-5 text-muted">
        Product not found
      </div>
    );
  }

  const finalPrice = getFinalPrice(product);

  return (
    <div className="container mt-4 mb-5">
      <button className="btn btn-link mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="row">
        {/* IMAGE */}
        <div className="col-md-5">
          <img
            src={getImage(product.images?.[0])}
            alt={product.name}
            className="img-fluid rounded shadow-sm"
          />
        </div>

        {/* DETAILS */}
        <div className="col-md-7">
          <small className="text-success fw-semibold">
            {product.category}
          </small>

          {product.unit && (
            <div className="text-muted small">{product.unit}</div>
          )}

          <h4 className="mt-2">{product.name}</h4>

          {product.description && (
            <p className="text-muted">{product.description}</p>
          )}

          {/* PRICE */}
          <div className="mb-3">
            {finalPrice !== product.price && (
              <span className="text-muted text-decoration-line-through me-2">
                ₹{product.price}
              </span>
            )}
            <span className="fw-bold text-success fs-5">
              ₹{finalPrice}
            </span>
          </div>

          {/* QUANTITY */}
          <div className="d-flex align-items-center gap-3 mb-3">
            <button
              className="btn btn-outline-secondary"
              onClick={() => setQty((q) => Math.max(1, q - 1))}
            >
              −
            </button>
            <span className="fw-bold fs-5">{qty}</span>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setQty((q) => q + 1)}
            >
              +
            </button>
          </div>

          {/* ACTIONS */}
          <div className="d-flex gap-3">
            <button className="btn btn-success" onClick={addToCart}>
              Add to Cart
            </button>
            <button className="btn btn-warning" onClick={buyNow}>
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;